import { render, staticRenderFns } from "./transferBill.vue?vue&type=template&id=cc6ed0ce&"
import script from "./transferBill.vue?vue&type=script&lang=js&"
export * from "./transferBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports